export default{

    startGame: ({commit, dispatch}, gameData) => {
        commit('startGameState')
        let game = {}
        game.currentScore = 16000
        game.currentEnigma = 1
        localStorage.setItem('gameData', game)
    },
    sumScore: ({commit, dispatch}, score) => {
        commit('sumScoreState', score)
        // let gameLocal = JSON.parse(localStorage.getItem('gameData'))
        // gameLocal.currentScore = gameLocal.currentScore + score
        // localStorage.setItem('gameData', JSON.stringify(gameLocal))
    },
    subScore: ({commit, dispatch}, score) => {
        commit('subScoreState', score)
        // let gameLocal = JSON.parse(localStorage.getItem('gameData'))
        // gameLocal.currentScore = gameLocal.currentScore - score
        // localStorage.setItem('gameData', JSON.stringify(gameLocal))
    },
    passCurrentEnigma: ({commit, dispatch}) => {
        commit('passCurrentEnigmaState')
        // let gameLocal = JSON.parse(localStorage.getItem('gameData'))
        // gameLocal.currentEnigma = gameLocal.currentEnigma + 1
        // localStorage.setItem('gameData', JSON.stringify(gameLocal)) 
    },
    addExtract: ({commit, dispatch}, extract) => {
        commit('addExtractState', extract)
        // console.log(extract)
        // let gameLocal = JSON.parse(localStorage.getItem('gameData'))
        // if(!gameLocal.extract){
        //     gameLocal.extract = []
        // }
        // gameLocal.extract.push(extract)
        // localStorage.setItem('gameData', JSON.stringify(gameLocal))
    }
}